import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { useBrandConfiguration } from '@search/core/brands/context';
import { Breadcrumb as SeoBreadcrumb } from '@seo/breadcrumb';
import { useAppContext } from '../../contexts/AppContext';
export const VariantABreadcrumbTestId = 'serp-variantA-breadcrumb-testid';
export const VariantBBreadcrumbTestId = 'serp-variantB-breadcrumb-testid';
const VariantB = ({ breadcrumb }) => (_jsx(Box, { width: "100%", maxWidth: "1280px", testId: VariantBBreadcrumbTestId, display: { 'breakpoint.base': 'none', 'breakpoint.sm': 'block' }, children: _jsx(SeoBreadcrumb, { links: breadcrumb, lastItemEllipsis: true, paddingLeft: "spacing.none", marginHorizontal: "spacing.none" }) }));
const VariantA = ({ breadcrumb }) => (_jsx(Box, { testId: VariantABreadcrumbTestId, width: "100%", maxWidth: "1280px", marginHorizontal: "auto", paddingHorizontal: {
        'breakpoint.base': 'spacing.16',
        'breakpoint.md': 'spacing.32',
    }, children: _jsx(SeoBreadcrumb, { links: breadcrumb, lastItemEllipsis: true }) }));
export const Breadcrumb = () => {
    const { variant } = useBrandConfiguration();
    const breadcrumb = useAppContext((store) => store.breadcrumb);
    // Prevent container display if no breadcrumbs
    if ((breadcrumb?.length ?? 0) === 0)
        return null;
    if (variant === 'flagship') {
        return _jsx(VariantA, { breadcrumb: breadcrumb });
    }
    return _jsx(VariantB, { breadcrumb: breadcrumb });
};
